import { SVGProps } from 'react'
import * as React from 'react'

const InfoIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={'24px'}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g id="УГУ" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Teacher-_add_step1"
          transform="translate(-728.000000, -318.000000)"
          fill={props.color ? props.color : '#D8D8D8'}
          fillRule="nonzero"
        >
          <g id="icon" transform="translate(728.000000, 318.000000)">
            <path
              d="M11.812,0 C5.289,0 0,5.289 0,11.812 C0,18.335 5.289,23.625 11.812,23.625 C18.335,23.625 23.625,18.335 23.625,11.812 C23.625,5.289 18.335,0 11.812,0 Z M14.271,18.307 C13.663,18.547 13.179,18.729 12.816,18.855 C12.454,18.981 12.033,19.044 11.554,19.044 C10.818,19.044 10.245,18.864 9.837,18.505 C9.429,18.146 9.226,17.691 9.226,17.138 C9.226,16.923 9.241,16.703 9.271,16.479 C9.302,16.255 9.351,16.003 9.418,15.72 L10.179,13.032 C10.246,12.774 10.304,12.529 10.35,12.301 C10.396,12.071 10.418,11.86 10.418,11.668 C10.418,11.326 10.347,11.086 10.206,10.951 C10.063,10.816 9.794,10.75 9.393,10.75 C9.197,10.75 8.995,10.779 8.788,10.84 C8.583,10.903 8.405,10.96 8.259,11.016 L8.46,10.188 C8.958,9.985 9.435,9.811 9.89,9.667 C10.345,9.521 10.775,9.449 11.18,9.449 C11.911,9.449 12.475,9.627 12.872,9.979 C13.267,10.332 13.466,10.791 13.466,11.355 C13.466,11.472 13.452,11.678 13.425,11.972 C13.398,12.267 13.347,12.536 13.273,12.783 L12.516,15.463 C12.454,15.678 12.399,15.924 12.349,16.199 C12.3,16.474 12.276,16.684 12.276,16.825 C12.276,17.181 12.355,17.424 12.515,17.553 C12.673,17.682 12.95,17.747 13.342,17.747 C13.527,17.747 13.734,17.714 13.968,17.65 C14.2,17.586 14.368,17.529 14.474,17.48 L14.271,18.307 Z M14.137,7.429 C13.784,7.757 13.359,7.921 12.862,7.921 C12.366,7.921 11.938,7.757 11.582,7.429 C11.228,7.101 11.049,6.702 11.049,6.236 C11.049,5.771 11.229,5.371 11.582,5.04 C11.938,4.708 12.366,4.543 12.862,4.543 C13.359,4.543 13.785,4.708 14.137,5.04 C14.49,5.371 14.667,5.771 14.667,6.236 C14.667,6.703 14.49,7.101 14.137,7.429 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default InfoIcon
